import {createContext, useContext} from "react";

const BusinessServiceContext = createContext(null);

export const useBusinessServiceContext = () =>
  useContext(BusinessServiceContext);

export default BusinessServiceContext;
